import React, { useEffect, useState } from 'react'
import MapWithFilters from './components/MapWithFilters'
import OutreachPage from './components/outreach/OutreachPage'

/* Маршруты без react-router: карта на «/», служебный дашборд рассылки на
   «/outreach...» (debug-режим). И nginx (try_files ... /index.html), и dev-сервер
   CRA отдают index.html на любой путь, так что прямая ссылка работает. */
function currentPath() {
  return typeof window !== 'undefined' ? window.location.pathname : '/'
}

function isOutreachPath(path) {
  return path === '/outreach' || path.startsWith('/outreach/')
}

export default function App(){
  const [path, setPath] = useState(currentPath)
  useEffect(() => {
    const onPop = () => setPath(currentPath())
    window.addEventListener('popstate', onPop)
    return () => window.removeEventListener('popstate', onPop)
  }, [])

  return (
    <div className="page">
      {isOutreachPath(path) ? <OutreachPage /> : <MapWithFilters />}
    </div>
  )
}
